import { Box, DialogContent, DialogTitle } from "@mui/material";
import { rolePermissionsBusiness } from "api/bussiness/user-role-permission/role-permission-bussiness";
import { AddRole as AddRoleModel } from "api/models/request/user-role/roles";
import { InputType } from "commons/ultilities/dynamic-form/models/control";
import { observer } from "mobx-react-lite";
import { useCallback } from "react";
import { string } from "yup";
import { DynamicForm } from "../../../../commons/ultilities/dynamic-form/components/dynamic-form";
import { useForm } from "../../../../commons/ultilities/dynamic-form/hooks/use-form";
import { useStores } from "../../../../mobx-stores/_root-store";
import { DialogForm } from "../../../../share-components/templates/form/dialog-form";

export const AddRole = observer(() => {
  const {
    rolePermissionManagement: { openNew, setProp, getRoles, pagination },
  } = useStores();
  const {
    form: { controls, isValid },
    submitHandler,
  } = useForm<AddRoleModel>(
    {
      name: {
        gridSize: 12,
        label: "Tên vai trò",
        type: InputType.text,
        validattionYupSchema: string().required().max(256),
      },
      // isDefault: {
      //   gridSize: 12,
      //   label: "Mặc định cho tất cả người dùng",
      //   type: InputType.checkbox,
      // },
    },
    {
      name: "",
      isDefault: false,
      isPublic: false,
    }
  );

  const saveHandler = useCallback(
    async (data: AddRoleModel) => {
      try {
        await rolePermissionsBusiness.addRole(data);
        await getRoles({ ...pagination.toBaseRequestModel() });
        setProp("openNew", false);
      } catch (ex) {}
    },
    [getRoles, pagination, setProp]
  );
  return (
    <DialogForm
      open={openNew}
      onClose={() => setProp("openNew", false)}
      onCancelBtnClicked={() => setProp("openNew", false)}
      onSaveBtnClick={async () => {
        await submitHandler(saveHandler);
      }}
      saveBtnProps={{
        disabled: !isValid,
      }}
    >
      <DialogTitle>Thêm mới vai trò</DialogTitle>
      <DialogContent>
        <Box sx={{ marginTop: "10px" }}>
          <DynamicForm controls={controls}></DynamicForm>
        </Box>
      </DialogContent>
    </DialogForm>
  );
});
